import { call, put, select, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { getRequest } from '~redux/selectors';
import { INTENT_ACTION } from '~redux/reducers/intent';
import { ERROR_ACTIONS } from '~redux/reducers/error';
import { getAirwayUrl } from '~components/utils';
import { POST_EVENTS, ExtendElementType, sendEvent } from '~components/events';
import { buildHeaders } from './confirm';

interface GetIntentPayload {
  type: string;
  payload: {
    id: string;
    componentName: ExtendElementType;
  };
}

export function* getPaymentIntentAsync(data: GetIntentPayload) {
  yield put({ type: ERROR_ACTIONS.SET, payload: {} });
  const { id, componentName } = data.payload || {};
  const request = yield select(getRequest);
  const reqPath = `${getAirwayUrl()}/payment_intents/${id}`;
  const reqHeader = buildHeaders(request);
  const logReqHeader = {
    ...reqHeader,
    'Awx-Tracker': null,
  };
  sendEvent(
    {
      type: componentName as ExtendElementType,
      code: POST_EVENTS.onLogRequest,
      path: reqPath,
      header: logReqHeader,
    },
    request.origin,
  );
  try {
    const { data: intent } = yield call([axios, 'get'], reqPath, reqHeader);
    sendEvent(
      {
        type: componentName as ExtendElementType,
        code: POST_EVENTS.onLogResponse,
        path: reqPath,
        res: intent,
        header: logReqHeader,
      },
      request.origin,
    );
    yield put({ type: INTENT_ACTION, payload: intent });
    if (componentName) {
      sendEvent(
        {
          type: componentName,
          code: POST_EVENTS.onIntentRetrieved,
          intent,
        },
        request.origin,
      );
    }
  } catch (error) {
    yield put({ type: ERROR_ACTIONS.SET, payload: error?.response?.data });
    sendEvent(
      {
        type: componentName,
        code: POST_EVENTS.onIntentRetrievedError,
        error: error?.response?.data,
      },
      request.origin,
    );
  }
}

export function* watchGetPaymentIntentAsync() {
  yield takeLatest('AWX_GET_PAYMENT_INTENT_ASYNC', getPaymentIntentAsync);
}
